/**
 * Purpose: Display labeled society contact numbers with tap-to-call links.
 * Inputs: contacts — array of { label, phone }.
 */
import React from 'react';
import { phoneTelHref } from '../../utils/societyContactNumbers';

const SocietyContactNumbers = ({ contacts }) => {
  const list = Array.isArray(contacts) ? contacts.filter((c) => c?.label && c?.phone) : [];
  if (list.length === 0) return null;

  return (
    <div className="mt-4 pt-4 border-t border-gray-100">
      <h3 className="text-sm font-semibold text-gray-900 mb-3">Important contacts</h3>
      <ul className="space-y-2">
        {list.map((entry, index) => {
          const tel = phoneTelHref(entry.phone);
          return (
            <li
              key={`${entry.label}-${entry.phone}-${index}`}
              className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1 rounded-lg border border-gray-100 bg-gray-50 px-3 py-2.5"
            >
              <span className="text-sm font-medium text-gray-800">{entry.label}</span>
              <a
                href={`tel:${tel}`}
                className="inline-flex items-center gap-1.5 text-sm text-emerald-700 font-medium hover:underline"
              >
                <svg className="w-4 h-4 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                  />
                </svg>
                {entry.phone}
              </a>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default SocietyContactNumbers;
